'use client';

import { SaveBarProps } from '@/components/SaveBar';
import { StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';
import { MediaAsset } from '@/types/media';
import { type ReactNode, createContext, useContext, useState } from 'react';

export const UIContext = createContext<{
  saveBar: SaveBarProps | null;
  setSaveBar: (saveBar: SaveBarProps | null) => void;
  mediaAsset: MediaAsset | null;
  setMediaAsset: (mediaAsset: MediaAsset | null) => void;
  studioVideo: StudioVideo | null;
  setStudioVideo: (studioVideo: StudioVideo | null) => void;
} | null>(null);

export interface UIProviderProps {
  children: ReactNode;
}

export const UIProvider = ({ children }: UIProviderProps) => {
  const [saveBar, setSaveBar] = useState<SaveBarProps | null>(null);
  const [mediaAsset, setMediaAsset] = useState<MediaAsset | null>(null);
  const [studioVideo, setStudioVideo] = useState<StudioVideo | null>(null);

  return (
    <UIContext.Provider
      value={{
        saveBar,
        setSaveBar,
        mediaAsset,
        setMediaAsset,
        studioVideo,
        setStudioVideo,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const uiContext = useContext(UIContext);

  if (!uiContext) {
    throw new Error(`useUI must be use within UIProvider`);
  }

  return uiContext;
};
